import { useLazyQuery } from '@apollo/client';
import { IncidentMessage } from '@bybeam/platform-types';
import env from '@platform-ui/utilities/env.js';
import { useEffect, useMemo } from 'react';
import GetActiveIncidentsQuery from '../graphql/queries/GetActiveIncidentsQuery.graphql';

interface ActiveIncidentProps {
  incidents: IncidentMessage[];
  loading: boolean;
}

const useActiveIncident = (partnerId?: string): ActiveIncidentProps => {
  const [executeQuery, { data, loading }] = useLazyQuery<
    { incidentMessages: { nodes: IncidentMessage[] } },
    { partnerId: string }
  >(GetActiveIncidentsQuery);

  useEffect(() => {
    executeQuery({ variables: { partnerId } });
  }, [partnerId]);

  const envIncidentMessage = env().REACT_APP_INCIDENT_MESSAGE;
  const memo = useMemo(
    () => ({
      incidents: [
        ...(envIncidentMessage
          ? [
              {
                id: 'environmentVariableMessage',
                severity: 1,
                message: envIncidentMessage,
              } as IncidentMessage,
            ]
          : []),
        ...(data?.incidentMessages?.nodes ?? []),
      ],
      loading,
    }),
    [data?.incidentMessages, envIncidentMessage, loading],
  );

  return memo;
};

export default useActiveIncident;
